import 'reflect-metadata';
import type ITenantSsoProviderRepository from '../ITenantSsoProviderRepository';
import type {
  TenantSsoProviderDTO,
  TenantSsoProviderCreateDTO,
  TenantSsoProviderUpdateDTO,
  TenantSsoProviderPublicDTO,
  TenantSsoProviderLookupDTO,
  AuthDiscoverRequestDTO,
  AuthDiscoverResultDTO,
} from '../tenantSsoProvider.types';
import { injectable } from 'inversify';
import API from '@repositories/Axios';

@injectable()
export class TenantSsoProviderRepository implements ITenantSsoProviderRepository {
  async getSsoProviders(tenantId: string): Promise<TenantSsoProviderDTO[]> {
    const result = await API.get<TenantSsoProviderDTO[]>(`/api/v1/tenants/${tenantId}/sso-providers`);
    return result.data;
  }

  async getSsoProvider(tenantId: string, providerId: string): Promise<TenantSsoProviderDTO> {
    const result = await API.get<TenantSsoProviderDTO>(
      `/api/v1/tenants/${tenantId}/sso-providers/${providerId}`,
    );
    return result.data;
  }

  async createSsoProvider(tenantId: string, dto: TenantSsoProviderCreateDTO): Promise<TenantSsoProviderDTO> {
    const result = await API.post<TenantSsoProviderDTO>(`/api/v1/tenants/${tenantId}/sso-providers`, dto);
    return result.data;
  }

  async updateSsoProvider(
    tenantId: string,
    providerId: string,
    dto: TenantSsoProviderUpdateDTO,
  ): Promise<TenantSsoProviderDTO> {
    const result = await API.put<TenantSsoProviderDTO>(
      `/api/v1/tenants/${tenantId}/sso-providers/${providerId}`,
      dto,
    );
    return result.data;
  }

  async deleteSsoProvider(tenantId: string, providerId: string): Promise<void> {
    await API.delete<void>(`/api/v1/tenants/${tenantId}/sso-providers/${providerId}`);
  }

  async lookupSsoProviders(dto: TenantSsoProviderLookupDTO): Promise<TenantSsoProviderPublicDTO[]> {
    const result = await API.post<TenantSsoProviderPublicDTO[]>('/api/v1/sso-providers/lookup', dto);
    return result.data;
  }

  async discoverLoginMethod(dto: AuthDiscoverRequestDTO): Promise<AuthDiscoverResultDTO> {
    const result = await API.post<AuthDiscoverResultDTO>('/api/v1/auth/discover', dto);
    return result.data;
  }
}
